module.exports = __webpack_public_path__ + "static/media/02-prepare-walkthrough.0ae1ae96.svg";